import axios from 'axios';
import VuexStore from '../store/index';

const apiClient = new axios.create({
    baseURL: '/api/v2',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

// catch 401 Unauthorized errors and logout the user
apiClient.interceptors.response.use(
    response => response,
    error => {
        // if unauthorized
        if (error.response.status === 401) {
            console.log('Intercepted "401 Unauthorized" response, logging out frontend...');
            VuexStore.dispatch('logout');
        }
        return Promise.reject(error);
    }
);

export default {
    setToken(token) {
        apiClient.defaults.headers.Authentication = 'Bearer ' + token;
    },
    login(applicationToken, payload) {
        return apiClient.post('/application/' + applicationToken + '/login', payload);
    },
    attachmentRemove(id) {
        return apiClient.delete('/attachment/' + id);
    },
    applicantAttachmentAdd(type, file, onProgressCallback) {
        const formData = new FormData();
        formData.set('type', type);
        formData.set('file', file);
        return apiClient.post('/applicant/attachment', formData, {
            onUploadProgress: onProgressCallback,
        });
    },
    householdAdultAttachmentAdd(householdAdultId, type, file, onProgressCallback) {
        const formData = new FormData();
        formData.set('type', type);
        formData.set('file', file);
        return apiClient.post('/applicant/household-adult/' + householdAdultId + '/attachment', formData, {
            onUploadProgress: onProgressCallback,
        });
    },
    step1Load() {
        return apiClient.get('/application/step1');
    },
    step1Submit(payload) {
        return apiClient.put('/application/step1', { data: payload });
    },
    step2Load() {
        return apiClient.get('/application/step2');
    },
    step2Submit(payload) {
        return apiClient.put('/application/step2', { data: payload });
    },
    step3Load() {
        return apiClient.get('/application/step3');
    },
    step3Submit(payload) {
        return apiClient.put('/application/step3', { data: payload });
    },
    step4Load() {
        return apiClient.get('/application/step4');
    },
    step4Submit(payload) {
        return apiClient.put('/application/step4', { data: payload });
    },
    step5Load() {
        return apiClient.get('/application/step5');
    },
    step5Submit(payload) {
        return apiClient.put('/application/step5', { data: payload });
    },
    step6Load() {
        return apiClient.get('/application/step6');
    },
    step6Submit(payload) {
        return apiClient.put('/application/step6', { data: payload });
    },
    step7Load() {
        return apiClient.get('/application/step7');
    },
    step7Submit(payload) {
        return apiClient.put('/application/step7', { data: payload });
    },
    step8Load() {
        return apiClient.get('/application/step8');
    },
    step8Submit(payload) {
        return apiClient.put('/application/step8', { data: payload });
    },
    step9Load() {
        return apiClient.get('/application/step9');
    },
    step9Submit(payload) {
        return apiClient.put('/application/step9', { data: payload });
    },
    finishLoad() {
        return apiClient.get('/application/finish');
    },
    finishSubmit(payload) {
        return apiClient.put('/application/finish', { data: payload });
    },
};
